import * as React from 'react';

/**
 * The component return checkmark icon
 * @return {React.ReactElement}
 * @constructor
 */
export default function Check(): React.ReactElement {
  return (
    <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.45022 0.354432C8.75897 0.0420123 9.25954 0.0420123 9.56828 0.354432C9.87703 0.666851 9.87703 1.17338 9.56828 1.4858L4.82476 6.2858C4.51601 6.59822 4.01544 6.59822 3.7067 6.2858L1.0714 3.61914C0.762658 3.30672 0.762658 2.80018 1.0714 2.48777C1.38015 2.17535 1.88072 2.17535 2.18946 2.48777L4.26573 4.58875L8.45022 0.354432Z" fill="currentColor"/>
    </svg>
  );
}

